module.exports = __webpack_public_path__ + "static/media/fundo_login.33edb0a8.png";